// import React from "react";
// import DropDownList from "./DropDownList";
// import {
//   AlertDialog,
//   AlertDialogContent,
//   AlertDialogDescription,
//   AlertDialogHeader,
//   AlertDialogTitle,
// } from "./ui/alert-dialog";
// import { useTranslation } from "react-i18next";

// export default function SelectOrderingMethod({
//   isOpen,
//   setOpen,
//   orderingMethodData,
//   selectedType,
//   setSelectedType,
//   handleOrderMethod,
//   open,
// }) {
//   const { t } = useTranslation();
//   return (
//     <React.Fragment>
//       {!open && (
//         <AlertDialog open={isOpen} onOpenChange={(isOpen) => setOpen(true)}>
//           <AlertDialogContent className="sm:max-w-[425px] overflow-y-auto max-h-[calc(100vh-6rem)]">
//             <AlertDialogHeader>
//               <AlertDialogTitle>
//                 {t("cart.ordering_method.title")}
//               </AlertDialogTitle>
//               <AlertDialogDescription>
//                 {t("cart.ordering_method.placeholder")}
//               </AlertDialogDescription>
//             </AlertDialogHeader>

//             <DropDownList
//               id="type"
//               className={"max-w-[300px]"}
//               label={t("cart.ordering_method.title")}
//               data={orderingMethodData}
//               placeholder={t("cart.ordering_method.placeholder")}
//               value={selectedType}
//               onValueChange={(e: any) => {
//                 setSelectedType(e);
//                 const url = new URL(window.location.href);
//                 const params = url.searchParams;
//                 params.set("type", e);
//                 setOpen(false);
//                 window.history.pushState(null, "", url.toString());
//                 handleOrderMethod({ method: e });
//               }}
//             />
//           </AlertDialogContent>
//         </AlertDialog>
//       )}
//     </React.Fragment>
//   );
// }

import React from "react";
import DropDownList from "./DropDownList";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { useTranslation } from "react-i18next";

export default function SelectOrderingMethod({
  orderingMethodData,
  selectedType,
  setSelectedType,
  handleOrderMethod,
  open,
}) {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <div className="space-y-1">
        <h3 className="text-base font-semibold leading-none tracking-tight">
          {t("cart.ordering_method.title")}
        </h3>
      </div>

      <DropDownList
        id="type"
        className={"max-w-[300px]"}
        // label={t("cart.ordering_method.title")}
        data={orderingMethodData}
        placeholder={t("cart.ordering_method.placeholder")}
        value={selectedType}
        onValueChange={(e: any) => {
          setSelectedType(e);
          const url = new URL(window.location.href);
          const params = url.searchParams;
          params.set("type", e);
          // setOpen(false);
          window.history.pushState(null, "", url.toString());
          handleOrderMethod({ method: e });
        }}
      />
    </div>
  );
}
